<template>
    <div>
        <div class="table-responsive" v-loading="loading">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Campaign</th>
                        <th>Setting</th>
                        <th></th>
                        <th>Delivery</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in my_data">
                        <td>
                            {{ row.name }}
                        </td>
                        <td>
                            <span v-if="row.job_id">Job {{ row.job_id }}, </span>
                            <span v-if="row.is_mc">MC, </span>
                            <span v-if="row.is_sc">Direct, </span>
                            <span v-if="row.is_owner_operator">OO, </span>
                        </td>
                        <td>
                            <i class="fad fa-exclamation-triangle fa-swap-opacity" style="color:#fc0;font-size:2rem;" v-if="row.inactive_warning" title="Assigned job is no longer active"></i>
                        </td>
                        <td>
                            {{ row.agent }}
                            {{ row.data }}
                        </td>
                        <td>
                            <btn :click="() => openDetail(row.id)">Update</btn>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <btn :click="() => newDelivery()">New Delivery</btn>

        <delivery-dialog
            :show="show_dialogs.delivery"
            :employer_id="employer_id"
            :delivery_id="delivery_id"
            :agents="agents"
            @close="show_dialogs.delivery = false; refresh()"
        ></delivery-dialog>
    </div>
</template>

<script>
import DeliveryDialog from "./dialogs/delivery-dialog";

export default {
    components: {DeliveryDialog},
    props: [
        'data',
        'agents',
        'employer_id'
    ],
    data() {
        return {
            show_dialogs: {
                delivery: false
            },
            delivery_id: null,
            my_data: this.data,
            loading: false
        };
    },
    computed: {
        currentAgent() {
        }
    },
    methods: {
        openDetail(rowId) {
            this.delivery_id = rowId;
            this.show_dialogs.delivery = true;
        },
        newDelivery() {
            this.delivery_id = 0;
            this.show_dialogs.delivery = true;
        },
        refresh() {
            this.loading = true;
            axios.get(url(`admin/employer/${this.employer_id}/delivery-list`))
                .then((response) => {
                    this.my_data = response.data;
                    this.loading = false;
                });
        }
    }
}
</script>